import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "headPage pageWidth" }
const _hoisted_2 = { class: "head_content" }
const _hoisted_3 = { class: "head flexXBetween pageWidth" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "hidden-md-and-up head_icon_menu" }
const _hoisted_6 = {
  class: "flexXBetween",
  style: {"width":"100%"}
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "flexXBetween" }
const _hoisted_9 = {
  key: 0,
  class: "drawerSubMenu"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "hidden-sm-and-down head_anchor" }
const _hoisted_12 = { class: "head_anchor_style" }
const _hoisted_13 = { class: "head_anchor_links" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "dropdown-item-content" }
const _hoisted_16 = {
  key: 0,
  class: "dropdown-item-image"
}
const _hoisted_17 = ["src", "alt"]
const _hoisted_18 = { class: "dropdown-item-title" }
const _hoisted_19 = {
  key: 0,
  class: "dropdown-item-subtitle"
}
const _hoisted_20 = {
  key: 0,
  class: "headPage_bgImg flexXBetween"
}
const _hoisted_21 = {
  key: 0,
  class: "headPage_bgImg_text"
}
const _hoisted_22 = { class: "headPage_bgImg_text_sub_title" }
const _hoisted_23 = { class: "headPage_bgImg_img" }
const _hoisted_24 = ["src"]

import { onMounted, reactive, watch, ref } from "vue";
import * as api from "@/api";
import store from "@/store";
import { useRoute, useRouter } from "vue-router";
interface routerArrayData {
  componentId: number;
  name: string;
}
interface toTemplateData {
  id: number;
  name: string;
  // query: Array<routerArrayData>
}

export default /*@__PURE__*/_defineComponent({
  __name: 'head',
  props: {
  logo: [],
},
  emits: ["scrollToBottom"],
  setup(__props, { emit: __emit }) {

const route = useRoute();
const router = useRouter();
let topBarIndex = 0;
const cid = {
  cid: process.env.VUE_APP_COMPANY,
};
const emits = __emit;
const props = __props;
//banner 的数据
const bannerData = ref<any>({});
const pageSrc = reactive({
  log: "页面创建了",
  topBarItems: [] as any,
  topBarIndex: 0,
  logo: "",
  banner: "",
  showBanner: true as boolean,
  fnBox: [] as any,
  keyCode: 0,
});
document.onkeydown = (e: any) => {
  pageSrc.keyCode = e.keyCode;
};
onMounted(() => {
  // console.debug(process.env, 'VUE_APP_APP_CODE');
  let adId = (route as any).query.adId;
  _fnPage.getTopBarItems();
  _fnPage.getFnBox();
  if (adId) {
    _fnPage.getBanner(adId);
  } else {
    router.push("/");
    _fnPage.getBanner(37);
  }
});
watch(
  () => route.fullPath,
  (n, o) => {
    if (n.indexOf("") && !(route as any).query.adId) {
      _fnPage.getBanner(37);
      pageSrc.topBarIndex = 0;
    }
  }
);
class FN_PAGE {
  setColor() {
    let pageAdId: any = route.query.adId;
    const res: any = {
      undefined: 0,
      "37": 0,
      "38": 1,
      "39": 2,
      "40": 3,
      "41": 4,
      "42": 5,
      "43": 6,
    };
    store.commit("setTopbarClickedIndex", res[pageAdId ? pageAdId : undefined]);
  }

  async getBanner(adId: number) {
    pageSrc.showBanner = false;
    try {
      const res = await api.getAdImgAndVideo(adId);
      store.commit("setTopBannerSource", res?.data.ad_list[0].pic);
      if (adId == 37)
        store.commit("setBannerSourceBackUp", res?.data.ad_list[0].pic);
      pageSrc.showBanner = true;
    } catch (e) {
      console.error(e);
    }
    this.setColor();
  }
  toTemplate(item: any, index: number, level: number) {
    if (item.path == "/" && !item?.children) {
      scrollToBottom();
      return;
    }
    if (item.path == "/") {
      return;
    }
    if (item.is_part == 1) return window.open(item.path, "_blank");
    const items = item.path.split("_");
    items[0] = items[0].split("/")[1];
    if (pageSrc.keyCode == 17) {
      pageSrc.keyCode = 0;
      const url: any = router.resolve({
        name: items[0],
        query: {
          componentId: items[1],
          name: encodeURIComponent(item.name),
          waitsources: item.id,
          adId: items[2],
        },
      });
      window.open(url.href);
      return;
    }
    router.push({
      name: items[0],
      query: {
        componentId: items[1],
        name: encodeURIComponent(item.name),
        waitsources: item.id,
        adId: items[2],
      },
    });
    this.getBanner(items[2]);
    if (level == 1) {
      pageSrc.topBarIndex = index;
      store.commit("setTopbarClickedIndex", index);
    } else {
      return;
    }
  }
  async getTopBarItems() {
    try {
      const res = await api.getTopBarItems(cid);
      pageSrc.topBarItems = res.data;
    } catch (e) {
      console.error(e);
    }
  }
  async getFnBox() {
    try {
      const res = await api.getPageMessage(122);
      bannerData.value = res?.data?.content_list[0];
    } catch (e) {
      console.error(e);
    }
  }
}
const _fnPage = new FN_PAGE();

const shwoDrawer = ref(false);
const expandedItems = ref<{ [key: number]: boolean }>({}); // 新增：用于跟踪展开的菜单项
function fun() {
  router.push("/");
}
// 新增：处理抽屉菜单点击事件
function handleDrawerItemClick(item: any, index: number) {
  if (item.children && item.children.length > 0 && index != 0) {
    // 切换子菜单展开状态
    expandedItems.value[index] = !expandedItems.value[index];
  } else {
    // 没有子菜单的项目直接导航
    _fnPage.toTemplate(item, index, 1);
    shwoDrawer.value = false;
  }
}
// 新增：处理子菜单项点击事件
function handleDrawerSubItemClick(
  subItem: any,
  parentIndex: number,
  subIndex: number
) {
  _fnPage.toTemplate(subItem, subIndex, 2);
  shwoDrawer.value = false;
}

const scrollToBottom = () => {
  emits("scrollToBottom", "");
};

return (_ctx: any,_cache: any) => {
  const _component_Operation = _resolveComponent("Operation")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_ArrowRightBold = _resolveComponent("ArrowRightBold")!
  const _component_ArrowDownBold = _resolveComponent("ArrowDownBold")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (props.logo)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "head_logo",
              onClick: fun
            }, [
              _createElementVNode("img", {
                class: "",
                src: props.logo,
                alt: "这个是logo"
              }, null, 8, _hoisted_4)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[2] || (_cache[2] = _createElementVNode("div", null, null, -1)),
            _createVNode(_component_el_icon, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (shwoDrawer.value = true)),
              color: "#333",
              size: "22",
              style: {"cursor":"pointer"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Operation)
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_el_drawer, {
            modelValue: shwoDrawer.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((shwoDrawer).value = $event)),
            direction: "rtl",
            size: "60%"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageSrc.topBarItems, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "drawerItem",
                  onClick: ($event: any) => (handleDrawerItemClick(item, index))
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", null, _toDisplayString(decodeURIComponent(item.name)), 1),
                    (item.children && item.children.length > 0 && index != 0)
                      ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                          default: _withCtx(() => [
                            (!expandedItems.value[index])
                              ? (_openBlock(), _createBlock(_component_ArrowRightBold, { key: 0 }))
                              : (_openBlock(), _createBlock(_component_ArrowDownBold, { key: 1 }))
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  (
                  expandedItems.value[index] &&
                  item.children &&
                  item.children.length > 0
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (subItem, subIndex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: subIndex,
                            class: "drawerSubItem",
                            onClick: _withModifiers(($event: any) => (
                    handleDrawerSubItemClick(subItem, index, subIndex)
                  ), ["stop"])
                          }, _toDisplayString(subItem.name), 9, _hoisted_10))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_7))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageSrc.topBarItems, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_dropdown, {
                  key: item.id,
                  trigger: "hover"
                }, _createSlots({
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: "head_anchor_link",
                      onClick: _withModifiers(($event: any) => (_unref(_fnPage).toTemplate(item, index, 1)), ["stop"])
                    }, [
                      _createTextVNode(_toDisplayString(item.name) + " ", 1),
                      (
                      index != 0 && item.children && item.children.length > 0
                    )
                        ? (_openBlock(), _createBlock(_component_el_icon, {
                            key: 0,
                            class: "dropdown-icon"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ArrowDownBold)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_14)
                  ]),
                  _: 2
                }, [
                  (index != 0 && item.children && item.children.length > 0)
                    ? {
                        name: "dropdown",
                        fn: _withCtx(() => [
                          _createVNode(_component_el_dropdown_menu, { class: "custom-dropdown-menu" }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (items, indexs) => {
                                return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                  key: indexs,
                                  onClick: ($event: any) => (_unref(_fnPage).toTemplate(items, indexs, 2))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_15, [
                                      (items.litpic)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                            _createElementVNode("img", {
                                              src: items.litpic,
                                              alt: items.name,
                                              class: "dropdown-item-img"
                                            }, null, 8, _hoisted_17)
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["dropdown-item-text", { 'no-image': !items.litpic }])
                                      }, [
                                        _createElementVNode("h4", _hoisted_18, _toDisplayString(items.name), 1),
                                        (items.sub_name)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(items.sub_name), 1))
                                          : _createCommentVNode("", true)
                                      ], 2)
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1024))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    (_unref(route).path == '/')
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          (bannerData.value?.title && _unref(route).path == '/')
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("h1", null, _toDisplayString(bannerData.value?.title), 1),
                _createElementVNode("p", _hoisted_22, _toDisplayString(bannerData.value?.sub_title), 1),
                _createElementVNode("button", {
                  class: "headPage_bgImg_text_btn",
                  onClick: scrollToBottom
                }, " 联系我们 ")
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("img", {
              src: _unref(store).state.topBannerSource,
              alt: "这个是背景图片"
            }, null, 8, _hoisted_24)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})